<template>
   <div ref="el" class="card-view" :class="{'is-collapse': isCollapse}">
    <div ref="header" :class="['card-view-header', headerClass, {'border': border}]"
      :style="{padding: headerPadding}">
      <h2 class="card-view-header-title"
        :style="{fontSize: titleFontSize}"
        v-if="title">{{title}}</h2>
      <i v-if="collapse" @click.stop="onTrigger" class="card-view-header-collapse jc-icon icon-arrow-up" :class="[{'is-collapse': isCollapse}]"></i>
      <slot name="header"></slot>
    </div>
    <slot name="header-des"></slot>
    <div ref="body" :class="['card-view-body', bodyClass, {'is-collapse': isCollapse}]"><slot></slot></div>
   </div>
</template>

<script>
import {addResizeListener} from '@/utils/resize-manager.js'
function getComputedStyle (dom, attr) {
  return document.defaultView.getComputedStyle(dom, null)[attr]
}
export default {
  name: 'card',
  props: {
    headerClass: {
      type: String
    },
    bodyClass: {
      type: String
    },
    title: String,
    border: Boolean,
    titleFontSize: {
      type: String,
      default: '18px'
    },
    headerPadding: {
      type: String,
      default: '28px 42px'
    },
    collapse: Boolean,
    onResize: {
      type: Function,
      default () {
        return () => {}
      }
    }
  },
  data () {
    return {
      isCollapse: false,
      height: 0,
      headerHeight: 0,
      bodyHeight: 0
    }
  },
  methods: {
    onTrigger () {
      if (!this.collapse) return
      this.isCollapse = !this.isCollapse
      if (!this.isCollapse) {
        this.$refs.body.style.height = `${this.bodyHeight}px`
        this.$emit('expanded')
      } else {
        this.$refs.body.style.height = '0px'
        this.$emit('collapsed')
      }
      this.$emit('trigger')
    },
    triggerResize () {
      this.__calculateSize()
    },
    __calculateSize () {
      setTimeout(() => {
        this.$refs.el && (this.height = this.$refs.el.scrollHeight)
        this.$refs.header && (this.headerHeight = this.$refs.header.scrollHeight)
        this.$refs.body && (this.bodyHeight = this.$refs.body.scrollHeight)
        // 判断下方是否存在search-form-wrapper
        if (this.$refs.body) {
          let searchWarpper = this.$refs.body.getElementsByClassName('search-form-wrapper')
          if (searchWarpper.length) {
            let height = Number(getComputedStyle(searchWarpper[0], 'height').replace('px', ''))
            this.$refs.body && (this.bodyHeight = height)
            if (!this.isCollapse) this.$refs.body.style.height = `${this.bodyHeight}px`
          }
        }
        typeof this.onResize === 'function' && this.onResize(this.isCollapse, this.height, this.headerHeight, this.bodyHeight)
      }, 20)
    }
  },
  mounted () {
    setTimeout(() => {
      addResizeListener(this.$refs.el, this.__calculateSize)
      this.__calculateSize()
    }, 20)
  }
}
</script>

<style lang="scss">
  .card-view {
    width: 100%;
    background: #fff;
    // border: 1px solid rgb(233, 233, 233);
    box-sizing: border-box;
    &.is-collapse {
      border-bottom: 0;
      .card-view-header-collapse {
        transform: rotate(180deg);
      }
      .card-view-body {
        padding: 0;
        overflow: hidden;
      }
    }
  .card-view-header {
    overflow: hidden;
    padding: 28px 42px;
    box-sizing: border-box;
    &-title {
      display: inline-block;
      font-size: 18px;
      font-weight: normal;
      line-height: 1;
      vertical-align: middle;
    }
    &.border {
      border-bottom: 1px solid rgb(233, 233, 233);
    }
    .card-view-header-collapse {
      float: right;
      vertical-align: middle;
      font-size: 20px;
      line-height: 21px;
      cursor: pointer;
      transition: all .2s;
    }
  }
  .card-view-body {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card.vue